import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHCargoUpd = async (credentials, data) => {
    const body = {
        service: "RNHCargoUpd",
        params: {
            rnhCargoId: data?.id,
            rnhCargoCod: data?.cod,
            rnhCargoNombre: data?.name,
            // `|| null` igual que el Ins: el vacio es la opcion "Todos", y lo que el
            // back guarda para eso es null, no un string vacio.
            rnhTipoComponenteCod: data?.componenteCod || null,
            // Bandera "Y"/"N" del cargo. Con `|| null` porque las dos son strings
            // truthy: viaja lo que el formulario tenga, y null si no vino.
            rnhCargoPuedeEditar: data?.puedeEditar || null,
            rnhCargoVersion: data?.version,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
